import React, { useEffect, useState } from "react";
import NetwalaModal from "../Items/Modal/Index";
import { Col, Row, Form } from "antd";
import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import NetwalaSelect from "../Items/Select/Index";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";

interface UpdateCompanyCityModalProps {
  show: boolean;
  handleClose: (isApiReload: boolean) => void;
  company: CompanyProp;
}

const UpdateCompanyCityModal: React.FC<UpdateCompanyCityModalProps> = ({
  show,
  handleClose,
  company,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [citiesOptions, setCitiesOptions] = useState<NetwalaSelectOptions[]>([]);

  const [
    fetchCities,
    citiesResponse,
    citiesError,
    citiesLoading,
  ] = useAxiosPost<ResponseProp>("superAdmin/getCities");

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("superAdmin/updateCompanyCity", true);

  useEffect(() => {
    if (show) {
      fetchCities({});
    }
  }, [show]);

  useEffect(() => {
    if (citiesResponse !== null && citiesResponse.responseData) {
      const cityList = citiesResponse.responseData;
      if (Array.isArray(cityList)) {
        const options: NetwalaSelectOptions[] = cityList.map((item: any) => {
          const cityName = typeof item === "string" ? item : item.City || item.city || "";
          return { label: cityName, value: cityName };
        });
        setCitiesOptions(options);
      }
    }
  }, [citiesResponse]);

  const onFinish = (values: any) => {
    const { city } = values;
    postApiData({ 
      city: city.trim(), 
      intPkCompanyID: company.intPkCompanyID 
    });
  };

  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);

  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title="Update Company City"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateCompanyCityForm"
              initialValues={{ city: company.city }}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">Select City</span>
                }
                name="city"
                rules={[
                  {
                    required: true,
                    message: "Please Select City",
                  },
                ]}
              >
                <NetwalaSelect
                  showSearch
                  allowClear
                  placeHolder="Select City"
                  options={citiesOptions}
                  disabled={citiesLoading}
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Update Company City"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateCompanyCityModal;
